export default {
    'Quick Start Guide': {
        'link.agent-installation': '[2020-04] Click WFBSS.link - Install the Security Agent on your endpoint',
        'link.configuring-policy': '[2020-04] Click WFBSS.link - Review or change your default policy settings',
        'link.provisioning-for-mic': '[2020-04] Click CAS.link - Set up Exchange Online (Office 365)',
        'link.provisioning-g-suite': '[2020-04] Click CAS.link - Set up Gmail (G Suite)',
        'link.provisioning-box': '[2020-04] Click CAS.link - Set up Box',
        'link.provisioning-dropbox': '[2020-04] Click CAS.link - Set up Dropbox',
        'link.provisioning-sharepoint': '[2020-04] Click CAS.link - Set up SharePoint Online / OneDrive for Business',
        'link.provisioning-googledrive': '[2020-04] Click CAS.link - Set up Google Drive',
        'link.advanced-threat-policy': '[2020-04] Click CAS.link - Advanced Threat Protection',
        'link.provisioning-business-account': '[2020-04] Click TMES.link - Complete the Trend Micro Business Account provisioning wizard',
        'link.domain-management': '[2020-04] Click TMES.link - Set up your email domain',
        'link.configuring-policies': '[2020-04] Click TMES.link - Review or change your default policy settings',
        'link.mx-records': '[2020-04] Click TMES.link - Point your MX record to Email Security',
    }
};
